/**
 * The MUI theme, built from the same tokens the POS's Tailwind preset reads.
 *
 * Every colour here is `var(--pos-…)`, so the two apps resolve to one value at runtime and a
 * palette change is a token edit rather than two. Tailwind is deliberately absent from this app:
 * mixing utility classes with emotion's generated styles produces specificity fights that get
 * fixed with `!important` and never get unfixed.
 */

import { createTheme, type Theme } from '@mui/material/styles';
// Side-effect import: this is what makes `MuiDataGrid` a recognised key of `Components` below.
// `@pos/tokens` cannot do this import itself — `@mui/x-data-grid` is a dependency of the apps
// that render a grid, not of the token package every app (including the Tailwind-only POS) loads.
import '@mui/x-data-grid/themeAugmentation';

import { dataGridStyleOverrides, muiThemeOptions } from '@pos/tokens/mui';

export function buildTheme(mode: 'light' | 'dark', shopThemeCode?: string): Theme {
  const options = muiThemeOptions(mode, shopThemeCode);

  return createTheme({
    ...options,
    components: {
      ...options.components,
      MuiDataGrid: { styleOverrides: dataGridStyleOverrides },
    },
  });
}
